export default __webpack_public_path__ + "static/media/Plats_Ajouter.c986f5d5.png";